import { createAction } from "redux-actions";
import {
	checkIsUserSignedIn,
	checkIsCodeRequested as checkIsCodeRequestedApi,
	requestCode as requestCodeApi,
	validateCode as validateCodeApi,
} from "../../services/signin";

export enum ACTIONS {
	REQUEST_CODE_ACTION = "SIGN_IN/REQUEST_CODE_ACTION",
	VALIDATE_CODE_ACTION = "SIGN_IN/VALIDATE_CODE_ACTION",
	CHECK_IS_SIGNED_IN = "SIGN_IN/CHECK_IS_SIGNED_IN",
	CHECK_IS_CODE_REQUESTED = "SIGN_IN/CHECK_IS_CODE_REQUESTED",
	SET_OPEN_MODAL = "SIGN_IN/SET_OPEN_MODAL",
	RESET_SIGN_IN_CHECK_DATA = "SIGN_IN/RESET_SIGN_IN_DATA",
}

export const requestCode = createAction(
	ACTIONS.REQUEST_CODE_ACTION,
	requestCodeApi
);
export const validateCode = createAction(
	ACTIONS.VALIDATE_CODE_ACTION,
	validateCodeApi
);
export const checkIsSignedIn = createAction(
	ACTIONS.CHECK_IS_SIGNED_IN,
	checkIsUserSignedIn
);

export const checkIsCodeRequested = createAction(
	ACTIONS.CHECK_IS_CODE_REQUESTED,
	checkIsCodeRequestedApi
);

export const setOpenModal = createAction(ACTIONS.SET_OPEN_MODAL);

export const resetSignInCheckData = createAction(
	ACTIONS.RESET_SIGN_IN_CHECK_DATA
);
